import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import * as bootstrap from 'bootstrap'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      bootstrap
    }
  }
})